// LOCAL TESTING ONLY
// import { createRequire } from "module";
// const require = createRequire(import.meta.url);
// const sampleData = require("./sampleScOrdersByCustomerResponse.json");
// const sampleOrdersList = sampleData && sampleData.Data.Orders;
export var adaptSCCommerceOrdersAPIToState = function adaptSCCommerceOrdersAPIToState(scCommerceOrdersFromRedux) {
  var dataFromApi = scCommerceOrdersFromRedux;
  var adaptedDataList = dataFromApi.reduce(function (acc, event) {
    var _Number$toFixed, _Number$toFixed2, _Number$toFixed3, _Number$toFixed4, _Number$toFixed5, _Number$toFixed6;

    // create mappedEventType prop based on if the string "purchase" is in event.eventType
    var adaptedData = {
      id: event.Id,
      mappedEventType: "orderItem",
      orderStatus: event.Status,
      transactionDate: event.OrderDate,
      transactionTotal: (_Number$toFixed = Number(event.Price.Total).toFixed(2)) !== null && _Number$toFixed !== void 0 ? _Number$toFixed : null,
      transactionTax: (_Number$toFixed2 = Number(event.Price.TaxTotal).toFixed(2)) !== null && _Number$toFixed2 !== void 0 ? _Number$toFixed2 : null,
      transactionSubtotal: (_Number$toFixed3 = Number(event.Price.Subtotal).toFixed(2)) !== null && _Number$toFixed3 !== void 0 ? _Number$toFixed3 : null,
      transactionTip: (_Number$toFixed4 = Number(event.Price.OloTip).toFixed(2)) !== null && _Number$toFixed4 !== void 0 ? _Number$toFixed4 : null,
      transactionGiftCardTotal: (_Number$toFixed5 = Number(event.Price.GiftCardTotal).toFixed(2)) !== null && _Number$toFixed5 !== void 0 ? _Number$toFixed5 : null,
      mappedOrderNumber: event.OrderNumber,
      handOffType: "Online",
      rewardRedeemedOnOrder: event.Price.TotalSavings !== 0 || null ? true : false,
      transactionSavings: (_Number$toFixed6 = Number(event.Price.TotalSavings).toFixed(2)) !== null && _Number$toFixed6 !== void 0 ? _Number$toFixed6 : null,
      rewardsPointsRedeemed: null,
      rewardsPointsEarned: null,
      orderStoreLocation: event.OloStoreComponent.StoreName,
      orderItems: event.CartLines || event.Items
    };
    acc.push(adaptedData);
    return acc;
  }, []); // comment out before merge and deploy
  // console.log(adaptedDataList);

  return adaptedDataList;
}; // LOCAL TESTING ONLY
// USAGE: node.exe src/lib/ducks/account/scCommerceOrdersAdapter.js > sampleAdaptedOrdersOutput.js
// adaptSCCommerceOrdersAPIToState(sampleOrdersList);